import { modalIds } from './modalRegistry';

export const viewAliases: Record<string, string> = {
  browse: "home-browse",
  github: "github-trending",
};

export { modalIds };
